import axios from './axios'
import {TblAnamnesiFamiliare  } from '@/../../EshJSLib/models/patient'
import {TblAnamnesiRemota } from '@/../../EshJSLib/models/patient'
import {TblAnamnesiProssima  } from '@/../../EshJSLib/models/patient'
import { TblAnamnesiFisiologica } from '@../../../EshJSLib/models/patient'
import { tbl_gravidanze } from '@../../../EshJSLib/models/patient'



export async function saveAnamnesiFamiliare(params: TblAnamnesiFamiliare) {
     const json = JSON.stringify(params);
     const response = await axios.post(`/api/anamnesiFamiliare`,json);
     return response.data;
}

export async function saveAnamnesiRemota (params: TblAnamnesiRemota) {
    const json = JSON.stringify(params);
    const response = await axios.post(`/api/anamnesiRemota`,json);
    return response.data;
}

export async function saveAnamnesiProssima(params: TblAnamnesiProssima) {
    const json = JSON.stringify(params);
    const response = await axios.post(`/api/anamnesiProssima`,json);
    return response.data;
}
export async function postAnamnesiFisologica(params: TblAnamnesiFisiologica) {
    const json = JSON.stringify(params);
    const response = await axios.post(`/api/anamnesiFisiologica`,json);
    return response.data;
}

export async function postGravidanze(params: tbl_gravidanze) {
    const json = JSON.stringify(params);
    const response = await axios.post(`/api/gravidanze`,json);
    return response.data;
}

export async function up_dateGravidanze(params: tbl_gravidanze) {
    const json = JSON.stringify(params);
    const response = await axios.put(`/api/gravidanze/`+ params.id_gravidanza,json);
    return response.data;
}

export async function delGravidanze(id: number) {
    const response = await axios.delete(`/api/gravidanze/`+id);
    return response.data;
}

export async function fetchAnamnesiFm(id : number) {
  
    const response = await axios.get(`/api/getAnamnesiFm/${id}`);
    return response.data;
 }

 export async function fetchAnamnesiRm(id : number) {
  
    const response = await axios.get(`/api/getAnamnesiRm/${id}`);
    return response.data;
 }

 export async function fetchAnamnesiPr(id : number) {
  
    const response = await axios.get(`/api/getAnamnesiPr/${id}`);
    return response.data;
 }

 export async function fetchAnamnesiFisiologica(id : number) {
  
    const response = await axios.get(`/api/getAnamnesiFisiologica/${id}`);
    return response.data;
 }

 export async function fetchGravidanze(id : number) {
  
    const response = await axios.get(`/api/getGravidanze/${id}`);
    return response.data;
 }
 